import script from "./UploadScormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadScormModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadScormModal.vue?vue&type=style&index=0&id=3d69a95c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d69a95c"]])

export default __exports__